'use strict';

angular.module('directives.empStaging')

.controller('empStagingMatchingContractRenewalController', ['$scope', 'employeeSyncService', function ($scope, employeeSyncService) {

    // Get Infos on Employee Contract Renewal
    employeeSyncService
             .getInfosOnEmployeeContractRenewal($scope.model)
             .then(function (infosOnContractRenewal) {
                 $scope.infosOnContractRenewal = infosOnContractRenewal;
             });

}]);